import React from 'react'
import SupplyFeedback from '@pages/Admin/Underwriting/ViewReport/SupplyFeedback'

const Supply = ({ data, update }) => {
	return <SupplyFeedback data={data} update={update} />
}

export default Supply
